export const scrollToWithNav = (y: number) => {
  const nav = document.getElementById('nav');
  const navHeight = nav ? nav.offsetHeight : 0;

  window.scroll({
    top: y - navHeight,
    left: 0,
    behavior: 'smooth',
  });
};
